import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-show-reason-dialog',
  templateUrl: './show-reason-dialog.component.html',
  styleUrls: ['./show-reason-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowReasonDialogComponent implements OnInit {

  excludedlist: any;
  loadingResults: boolean;
  currentLang: any;

  constructor(private dialogRef: MatDialogRef<ShowReasonDialogComponent>,
    private _translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.currentLang =
      this._translateService.currentLang === 'es'
        ? 'es_AR'
        : this._translateService.currentLang;
  }

  ngOnInit(): void {
    if (this.data) {
      this.loadingResults = true;
      this.excludedlist = this.data;
    }
    this.loadingResults = false;
  }

  isKeyValueObj(value): boolean {
    if (typeof (value) === 'object' ) {
      return true;
    } else {
      return false;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
